module.exports = __webpack_public_path__ + "static/media/thumbsDownRed.ee91ea81.png";